// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1jPcJ","copyright":"Footer_copyright__1rv2-"};